import { Skeleton, Stack } from '@mui/material';

export const HeaderMiniCartDropMenuItemSkeleton = ({
	variant = 'mini',
}: {
	variant?: 'mini' | 'drawer';
}) => (
	<Stack direction="row" spacing={2}>
		<Skeleton
			variant="rectangular"
			width={variant === 'mini' ? 64 : 105}
			height={variant === 'mini' ? 64 : 105}
		/>
		<Stack spacing={0.3}>
			<Skeleton variant="text" width={172} height={20} />
			<Stack direction="row" spacing={2}>
				<Skeleton variant="text" width={70} height={20} />
				<Skeleton variant="text" width={70} height={20} />
			</Stack>
			<Skeleton width={120} height={20} />
		</Stack>
	</Stack>
);
